import { actions } from './home/actions'

export default {
    namespaced: true,
    actions
}